import type { IAdProvider, AdStatus, AdProviderConfig } from '../types';

declare global {
  interface Window {
    initCdTma: (config: { id: string }) => Promise<() => Promise<void>>;
  }
}


export class OnclickaProvider implements IAdProvider {
  readonly providerId = 'onclicka' as const;
  private status: AdStatus = 'idle';
  private statusCallbacks: Array<(status: AdStatus) => void> = [];
  private config: AdProviderConfig;
  private showAdFn: (() => Promise<void>) | null = null;

  constructor(config: AdProviderConfig) {
    this.config = config;
  }

  getStatus(): AdStatus {
    return this.status;
  }

  onStatusChange(callback: (status: AdStatus) => void): void {
    this.statusCallbacks.push(callback);
  }

  private setStatus(status: AdStatus) {
    this.status = status;
    this.statusCallbacks.forEach(cb => cb(status));
  }

  async init(): Promise<void> {
    if (typeof window === 'undefined') return;

    if (typeof window.initCdTma === 'function') {
      this.setStatus('ready');
      return;
    }

    this.setStatus('loading');
    // TODO: 根據 Onclicka 文檔添加正確的 SDK 加載邏輯
    const script = document.createElement('script');
    script.src = 'https://js.onclckvd.com/in-stream-ad-admanager/tma.js';
    document.head.appendChild(script);

    return new Promise((resolve, reject) => {
      script.onload = () => {

        window.initCdTma?.({ id: this.config.spotId as string }).then((showAd) => {
          this.showAdFn = showAd;
          console.log('[Onclicka] SDK loaded');
          this.setStatus('ready');
          resolve();
        }).catch((error) => {
          console.error('[Onclicka] Failed to initialize SDK', error);
          this.setStatus('error');
          reject(new Error('Failed to initialize Onclicka SDK'));
        });
      };
      script.onerror = () => {
        console.error('[Onclicka] Failed to load SDK');
        this.setStatus('error');
        reject(new Error('Failed to load Onclicka SDK'));
      };
    });
  }

  async open(): Promise<any> {
    try {
      if (!this.showAdFn) {
        throw new Error('Onclicka SDK is not initialized. Call init() first.');
      }
      const data = await this.showAdFn();
      return data;
    } catch (error) {
      console.error('[Onclicka] Failed to open ad', error);
      throw error;
    }
  }
}
